// Web analytics implementation
const AMPLITUDE_API_KEY = process.env.EXPO_PUBLIC_AMPLITUDE_API_KEY;

let initialized = false;

export async function initAnalytics() {
  if (!AMPLITUDE_API_KEY) {
    if (__DEV__) console.warn('[analytics] Missing Amplitude API key for web');
    return;
  }
  
  try {
    // For web, we can use the browser SDK or just log for now
    initialized = true;
    if (__DEV__) console.log('[analytics] Web analytics initialized');
  } catch (e) {
    console.error('[analytics] Failed to init web analytics', e);
  }
}

export function track(event: string, props?: Record<string, any>) {
  if (!initialized) {
    if (__DEV__) console.warn('[analytics] track called before init');
    return;
  }
  
  try {
    // For web, we can log events or send to analytics service
    if (__DEV__) {
      console.log('[analytics] Track event:', event, props);
    }
    // In production, you would send this to your analytics service
  } catch (e) {
    if (__DEV__) console.error('[analytics] track error', e);
  }
}

export function setUserId(id: string) {
  if (!initialized) return;
  if (__DEV__) {
    console.log('[analytics] Set user ID:', id);
  }
  // In production, you would set the user ID in your analytics service
}